import { lazy } from "react"

export const DispatcherTimeCoordinatePage = lazy(() => import("./DispatcherTimeCoordinatePage"))
